import { Link } from "react-router-dom";
import { useCatalog } from "../context/CatalogContext";
import { CategoryImage } from "./CategoryImage";
import { Sparkles } from "lucide-react";

export default function CategoryNav() {
  const { categories: cats } = useCatalog();

  return (
    <nav className="bg-white border-b border-border sticky top-[64px] z-40" data-testid="category-nav">
      <div className="container-x">
        <ul className="flex items-center gap-1 overflow-x-auto py-2 no-scrollbar font-heading">
          {cats.map((c) => {
            return (
              <li key={c.slug}>
                <Link
                  data-testid={`cat-nav-${c.slug}`}
                  to={`/category/${c.slug}`}
                  className="flex items-center gap-2 px-4 py-2 whitespace-nowrap text-sm font-medium text-charcoal hover:text-terracotta border-b-2 border-transparent hover:border-terracotta transition-all"
                >
                  <span className="w-6 h-6 overflow-hidden rounded-sm"><CategoryImage category={c} /></span>
                  {c.name}
                </Link>
              </li>
            );
          })}
          <li className="ml-auto">
            <Link
              data-testid="cat-nav-ai-designer"
              to="/ai-designer"
              className="flex items-center gap-2 px-4 py-2 whitespace-nowrap text-sm font-semibold text-terracotta hover:bg-terracotta hover:text-off-white transition-colors border border-terracotta"
            >
              <Sparkles className="w-4 h-4" />
              Design my room
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}
